import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { startWith, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ClientaccountService } from 'src/app/services/apiclient/clientaccount/clientaccount.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { redirectUnauthorizedTo } from '@angular/fire/auth-guard';


@Component({
  selector: 'app-client-phone',
  templateUrl: './client-phone.component.html',
  styleUrls: ['./client-phone.component.css'],
})
export class ClientPhoneComponent implements OnInit {


  @ViewChild('autoCompleteCountry', { read: MatAutocompleteTrigger }) acCountry: MatAutocompleteTrigger | any;
  innerHeight: number = window.innerHeight;


  // Loaders
  loaders: any = {
    page: true,
    forms: false,
    countries: false
  };
  statusMessage: string | any;

  // Forms
  phoneForm: FormGroup | any;


  //Filtered data
  filteredCountries: Observable<any> | any;

  clientAccount$: any;
  error$: string | any;
  countries$: any


  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<ClientPhoneComponent>,
    private clientApi: ClientaccountService,
    private auth: AuthService,
    private formBuilder: FormBuilder
  ) {

    this.clientAccount$ = data.clientAccount;

    this.countries$ = data.countries;

    this.auth.getError.subscribe((data) => {
      this.error$ = data;
    });

  }

  ngOnInit() {
    // this.dialogRef.disableClose = true;
    this.createPhoneForm();
  }


  createPhoneForm(): void {
    this.phoneForm = this.formBuilder.group({
      phone: [{ value: '', disabled: true }, [Validators.required, Validators.pattern("[^a-zA-Z]{1,}")]],
      country_name: ['', [Validators.required]],
      id_country: '',
    });


    this.getCountriesOnChange();

    this.phoneForm.get('phone').disable();


  }


  clearFilter() {

    let input = this.phoneForm.get('phone')
    this.phoneForm.get('country_name').valid ? input.enable() : input.disable();

  }

  submitNewPhone(formDirective: FormGroupDirective, panel: any): void {
    const that = this;
    const params = {
      phone: that.phoneForm.value.phone,
      id_country: that.phoneForm.value.id_country
    };

    if (that.phoneForm.valid) {

      that.beforeCallApi("Modification de votre téléphone");

      that.auth.updateClient(params, "successphone").then(data => {

        that.afterCallApi(panel, formDirective, data);

      });
    }
  }

  reLog() {
    this.auth.logOut("/auth/home%22account");
  }

  // Automate stains

  beforeCallApi(message: string) {
    this.statusMessage = message;
    this.error$ = "";
    this.loaders.forms = true;
  }

  afterCallApi(panel: any, formDirective: FormGroupDirective, data: any) {
    if (data) {
      this.clientApi.setCurrClientAccount(data);

      this.closeDial(data);
    }

    this.loaders.forms = false;
  }

  // Autocomplete countries

  onSelectCountry(country: any): void {
    this.phoneForm.get("id_country").setValue(country.id);

    // phone_code
    this.phoneForm.get("phone").reset();

    this.setIndicatif();

  }

  setIndicatif() {
   
   
    if (this.phoneForm.value.id_country && this.phoneForm.value.id_country!==79) {
      let ind = this.filteredCountries.find((value: any) => (value.id == this.phoneForm.value.id_country));
    
      if (ind && ind.phone_code) {
        this.phoneForm.get("phone").setValue(ind.phone_code);
      }
    }


  }
  getIndicatif() {
    let result = null
    if (this.phoneForm.value.id_country) {
      let ind = this.filteredCountries.find((value: any) => (value.id == this.phoneForm.value.id_country));
      if (ind && ind.phone_code) {
        result = ind.phone_code
      }
    }
    return result;

  }

  getCountriesOnChange(): void {

    this.phoneForm.get("country_name").valueChanges
      .pipe(
        startWith(''),
        tap(() => {
          this.loaders.countries = true;
        }),
      )
      .subscribe((value: any) => {

        if (value) {

          const filteredValueResults = this.filterCountries(value);
          this.filteredCountries = (filteredValueResults.length > 0) ? filteredValueResults : null;

        } else {

          this.filteredCountries = this.countries$.slice();



        }
       
        this.loaders.countries = false;

      });
  }

  filterCountries(value: string): any {
    const filterValue = value.toLowerCase();
    return this.countries$.filter((country: any) => country.name.toLowerCase().indexOf(filterValue) === 0);
  }

  closeDial(data?: any) {

    if (data && !this.phoneForm.valid) {
      return;
    }

    this.dialogRef.close(data);
  }



}
